import { NativeStackNavigationOptions, createNativeStackNavigator } from "@react-navigation/native-stack";
import EventDetailsScreen from "./EventDetailsScreen";
import EventRegistrationScreen from "./EventRegistrationScreen";
import EventConfirmationScreen from "./EventConfirmationScreen";
import EventTicketScreen from "./EventTicketScreen";
import { ScreenOptionsFnProps } from "../../components/HeaderBackButton";
import { RootStackParamList } from "../types";

export const Stack = createNativeStackNavigator<RootStackParamList>();

type ScreenOptions =
  | NativeStackNavigationOptions
  | ((props: ScreenOptionsFnProps<RootStackParamList>) => NativeStackNavigationOptions);

export default function EventScreens(screenOptions: ScreenOptions) {
  return (
    <Stack.Group screenOptions={screenOptions}>
      <Stack.Screen
        name="EventDetails"
        component={EventDetailsScreen}
        options={{ headerShown: false, title: "Event Details" }}
      />
      <Stack.Screen name="EventRegistration" component={EventRegistrationScreen} options={{ title: "Event Registration" }} />
      <Stack.Screen name="EventConfirmation" component={EventConfirmationScreen} options={{ title: "Event Confirmation" }} />
      <Stack.Screen name="EventTicket" component={EventTicketScreen} options={{ title: "Event Access Pass" }} />
    </Stack.Group>
  );
}
